import styled from 'styled-components'
export const Wrapper = styled.span`
  cursor: pointer;
  svg {
    font-size: 1.2rem;
  }
`
